import {DomainEvent} from './DomainEvent';
import {DeletedEntity} from '../resources/DeletedEntity';

export class ProfileTransferDeleted extends DomainEvent<DeletedEntity> {}
